<template lang="html">
  <div class="i-group-cell">
    <div v-if="title" class="i-group-cell-title">
      <div class="i-group-cell-title-bar"></div>
      <div class="i-group-cell-title-text">&nbsp;{{title}}</div>
    </div>
    <div class="i-group-cell-items">
      <slot></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: 'i-group-cell',
  props: {
    title: String,
    default: null,
  },
};
</script>

<style lang="scss" scoped>
.i-group-cell {
  .i-group-cell-title {
    padding: 10px 16px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: flex-start;
    .i-group-cell-title-bar {
      display: inline-block;
      width: 5px;
      background: #2e6be6;
      border-radius: 100px;
      margin-right: 5px;
    }
    .i-group-cell-title-text {
      font-size: 16px;
    }
  }
}
</style>
